import { z } from 'zod';

export const loginSchema = z.object({
  email: z.string().email(),
  password: z.string().min(1),
});
export type LoginInput = z.infer<typeof loginSchema>;

export const acceptInviteSchema = z.object({
  full_name: z.string().min(1).max(255),
  password: z.string().min(8),
});
export type AcceptInviteInput = z.infer<typeof acceptInviteSchema>;
